import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles

const TextEditor = () => {
  const [editorHtml, setEditorHtml] = useState("");

  const handleEditorChange = (html) => {
    setEditorHtml(html);
  };

  const modules = {
    toolbar: [
      [{ font: [] }],
      ["bold", "italic", "underline", { color: [] }],
      [{ align: [] }],
    ],
  };

  //   const formats = ["header", "bold", "italic", "underline","color"];

  return (
    <div className="quill-text-area"  style={{ height: 394, background: "white", borderRadius: 10, overflow: "hidden", boxShadow:"20px" }}>
      <ReactQuill
        value={editorHtml}
        onChange={handleEditorChange}
        modules={modules}
        placeholder="Description"
        style={{ height: 350, border: 0 }}
        // formats={formats}
      />
    </div>
  );
};

export default TextEditor;
